import { SliderField } from 'common/components/FormField';
import { EFilterType, IFilterFormItem, TRangeFilterValue } from 'common/types';
import {
    offerEventsFilter,
    startDateRangeFilter,
    userGroupsFilter,
} from 'common/utils/drawerFilters';
import { getRangeFilterDisplay } from 'common/utils/filter';
import { IOfferEventSubscriptionStatus, IOfferEventType } from 'graphql/types';
import { OFFER_TYPE_FILTERS } from 'offer/constants/offer';
import { translate } from 'utils/i18n';

export function getFilterForType(type: IOfferEventType) {
    return OFFER_TYPE_FILTERS.find((filter) => filter.types.includes(type));
}

export function attendanceFilter(
    transKey = 'offerEventManageableEnrollmentFilters.attendance'
): IFilterFormItem<TRangeFilterValue> {
    return {
        key: 'attendance',
        label: translate(`${transKey}.sectionTitle`),
        fields: [
            {
                name: 'attendance',
                type: EFilterType.Range,
                initialValue: [0, 1],
                component: SliderField,
                componentProps: {
                    min: 0,
                    max: 1,
                    step: 0.01,
                    valueLabelFormat: (value: string) =>
                        `${Math.floor(+value * 100)}%`,
                    marks: [
                        {
                            value: 0,
                            label: '0%',
                        },
                        {
                            value: 1,
                            label: '100%',
                        },
                    ],
                },
                chip: {
                    label: translate(`${transKey}.chip`),
                    parseValue: getRangeFilterDisplay,
                    appendValue: '%',
                },
            },
        ],
    };
}

export function getEnrollmentsManagementFilters(
    enrollmentStatus: IOfferEventSubscriptionStatus
): IFilterFormItem[] {
    const baseFilters = [
        startDateRangeFilter(
            'offerEventManageableEnrollmentFilters.startDateRange',
            'dateFrom',
            'dateTo'
        ),
        userGroupsFilter(undefined, 'groupIds'),
    ];

    if (enrollmentStatus !== IOfferEventSubscriptionStatus.Enrolled) {
        return baseFilters as IFilterFormItem[];
    }

    return [
        ...baseFilters,
        attendanceFilter(),
        offerEventsFilter(
            'offerEventManageableEnrollmentFilters.meetings',
            'eventIds',
            {
                isFilter: true,
                offerEventTypes: [
                    IOfferEventType.Meeting,
                    IOfferEventType.Webinar,
                ],
            }
        ),
    ] as IFilterFormItem[];
}
